import dayjs from "dayjs";
import { getFirstLetterUpperCaseRestLowerCase } from "shared/utils/commons";

export default (selectedDate: Date): string =>
  dayjs(selectedDate)
    .format("dddd DD MMMM")
    .split(" ")
    .map((word) => getFirstLetterUpperCaseRestLowerCase(word))
    .join(" ");
